export default "__VITE_ASSET__By5QUc7N__"